import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";

import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import IntangibleAssetBalanceFilters from "./components/IntangibleAssetFilter";
import IntangibleAssetBalanceTable from "./components/IntangibleAssetTable";

const { Title } = Typography;

const IntangibleAssetBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.intangibleAssetBalance);

  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Intangible Asset Balance Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Intangible Asset Balance Report
            </Title>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              {!screens.xs && "Print"}
            </Button>
          }
        />

        <IntangibleAssetBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <IntangibleAssetBalanceTable />
        </Card>
      </App>

      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Intangible Asset Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <IntangibleAssetBalanceTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default IntangibleAssetBalance;